// extracted by mini-css-extract-plugin
export default {"fleetAircraftAccordion":"FleetAircraftAccordion_fleetAircraftAccordion__LWXhu"};